import createLucideIcon from '../createLucideIcon';

const AlignRight = createLucideIcon('AlignRight', [
  ['line', { x1: '21', x2: '3', y1: '6', y2: '6', key: '1fp77t' }],
  ['line', { x1: '21', x2: '9', y1: '12', y2: '12', key: '1uyos4' }],
  ['line', { x1: '21', x2: '7', y1: '18', y2: '18', key: '1g9eri' }],
]);

export default AlignRight;
